'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419 from "./presto.-Login-Page-View$$anon$19.js";
import * as $j_presto$002etypes$0024$002dAccount$002dId$0024 from "./presto.types$-Account-Id$.js";
import * as $j_presto$002etypes$0024$002dEmail$0024 from "./presto.types$-Email$.js";
import * as $j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024 from "./presto.types$-Morbid-User-Details$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginPageView$$anon$18() {
  this.b6Z = null;
  this.b6R = null;
  this.b6S = false;
  this.b70 = null;
  this.b71 = false;
  this.b74 = null;
  this.b6X = null;
  this.b6Y = false;
  this.b6T = null;
  this.b6U = false;
  this.b6V = null;
  this.b6W = false;
  this.b72 = false;
  this.b73 = false;
  this.b6Z = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b74 = "MorbidUserDetails";
}
export { $c_Lpresto_LoginPageView$$anon$18 as $c_Lpresto_LoginPageView$$anon$18 };
$p = $c_Lpresto_LoginPageView$$anon$18.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginPageView$$anon$18;
/** @constructor */
function $h_Lpresto_LoginPageView$$anon$18() {
}
export { $h_Lpresto_LoginPageView$$anon$18 as $h_Lpresto_LoginPageView$$anon$18 };
$h_Lpresto_LoginPageView$$anon$18.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.b6Z;
});
$p.M = (function() {
  if ((!this.b6S)) {
    this.b6R = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b6S = true;
  }
  return this.b6R;
});
$p.O = (function() {
  if ((!this.b71)) {
    this.b70 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b71 = true;
  }
  return this.b70;
});
$p.D = (function() {
  return this.b74;
});
$p.t = (function() {
  if ((!this.b6Y)) {
    this.b6X = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("email", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("account", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b6Y = true;
  }
  return this.b6X;
});
$p.N = (function() {
  if ((!this.b6U)) {
    this.b6T = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dEmail$0024.$m_Lpresto_types$Email$().cJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dAccount$002dId$0024.$m_Lpresto_types$AccountId$().bl(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.b6U = true;
  }
  return this.b6T;
});
$p.Q = (function() {
  if ((!this.b6W)) {
    this.b6V = new $j_presto$002e$002dLogin$002dPage$002dView$0024$0024anon$002419.$c_Lpresto_LoginPageView$$anon$19();
    this.b6W = true;
  }
  return this.b6V;
});
$p.v = (function() {
  if ((!this.b73)) {
    this.b72 = false;
    this.b73 = true;
  }
  return this.b72;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee126) => ((p) => \u03b4scrutinee126.H3(p)))($j_presto$002etypes$0024$002dMorbid$002dUser$002dDetails$0024.$m_Lpresto_types$MorbidUserDetails$())));
});
var $d_Lpresto_LoginPageView$$anon$18 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginPageView$$anon$18, "presto.LoginPageView$$anon$18", ({
  Mi: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginPageView$$anon$18 as $d_Lpresto_LoginPageView$$anon$18 };
//# sourceMappingURL=presto.-Login-Page-View$$anon$18.js.map
